import { SVGIconProps } from './types'

export const SVGIcon = (props: SVGIconProps) => (
  <svg
    width="15"
    height="15"
    fill="none"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.852 9.23a6.042 6.042 0 0 0-2.504-3.526h3.687a.5.5 0 1 0 0-1H9.973a2 2 0 0 0-3.875 0H1.035a.5.5 0 0 0 0 1h3.688A6.043 6.043 0 0 0 2.218 9.23a2 2 0 1 0 1.01.1 5.037 5.037 0 0 1 2.995-3.286 2 2 0 0 0 3.628 0 5.038 5.038 0 0 1 2.992 3.285 2 2 0 1 0 1.009-.098V9.23ZM3.535 11.204a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm4.5-5a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm5.5 6a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"
      fill="currentColor"
    />
  </svg>
)
